module.exports = __webpack_public_path__ + "media/img/seed/10-9527e510aef02ee08c69695de5a4de27.jpeg";